import { lazy } from 'react';
import { EnumBehaviorKey } from 'src/types/Behaviors';
import { AppRoute } from 'src/types/Route';

const Database = lazy(
  () =>
    import(
      /* webpackChunkName: "Database" */ 'src/pages/Backstage/subPages/DataSource/DataBase'
    ),
);

const Dataset = lazy(
  () =>
    import(
      /* webpackChunkName: "DataSet" */ 'src/pages/Backstage/subPages/DataSource/Dataset'
    ),
);

const DatasetAdd = lazy(
  () =>
    import(
      /* webpackChunkName: "DatasetAdd" */ 'src/pages/Backstage/subPages/DataSource/Dataset/subPages/DatasetAdd'
    ),
);

const DatasetEdit = lazy(
  () =>
    import(
      /* webpackChunkName: "DatasetEdit" */ 'src/pages/Backstage/subPages/DataSource/Dataset/subPages/DatasetEdit'
    ),
);

const TopicConfig = lazy(
  () =>
    import(
      /* webpackChunkName: "TopicConfig" */ 'src/pages/Backstage/subPages/DataSource/TopicConfig'
    ),
);

const DataPermissionSet = lazy(
  () =>
    import(
      /* webpackChunkName: "DataPermissionSet" */ 'src/pages/Backstage/subPages/DataSource/TopicConfig/subPages/data-permission-set'
    ),
);

const dataSourceRoutes: AppRoute[] = [
  {
    name: '数据库连接',
    path: '/backstage/data-source/list-database',
    Component: Database,
    behaviors: [EnumBehaviorKey.DATA_ACCESS_MANAGE],
  },
  {
    name: '添加数据集',
    path: '/backstage/data-source/add-dataset',
    Component: DatasetAdd,
    hideInPanel: true,
    behaviors: [EnumBehaviorKey.DATA_ACCESS_MANAGE],
  },
  {
    name: '编辑数据集',
    path: '/backstage/data-source/edit-dataset',
    Component: DatasetEdit,
    hideInPanel: true,
    behaviors: [
      EnumBehaviorKey.DATA_ACCESS_MANAGE,
      EnumBehaviorKey.DATA_COMMENT_MAINTENANCE,
      EnumBehaviorKey.DATA_RESPONSIBILITY_DIVIDE,
    ],
  },
  {
    name: '数据集接入',
    path: '/backstage/data-source/list-dataset',
    Component: Dataset,
    keepAlive: true,
    behaviors: [
      EnumBehaviorKey.DATA_ACCESS_MANAGE,
      EnumBehaviorKey.DATA_PREVIEW,
      EnumBehaviorKey.DATA_COMMENT_MAINTENANCE,
      EnumBehaviorKey.DATA_RESPONSIBILITY_DIVIDE,
    ],
  },
  {
    name: '主题管理',
    path: '/backstage/data-source/topic-config',
    Component: TopicConfig,
    behaviors: [EnumBehaviorKey.ANALYZE_PERMISSION_MANAGE],
  },
  {
    name: '数据权限设置',
    path: '/backstage/data-source/data-permission-set',
    Component: DataPermissionSet,
    hideInPanel: true,
    behaviors: [EnumBehaviorKey.ANALYZE_PERMISSION_MANAGE],
  },
];

export default dataSourceRoutes;
